import { Box } from "@mui/material";
import { GridRow, GridRowProps, GridValidRowModel } from "@mui/x-data-grid-pro";
import { memo, useRef } from "react";
import { testIds } from "../LynksTable.testIds";

type DataGridCustomRowProps = GridRowProps & {
  rowDataAttributes?: (
    row: GridValidRowModel
  ) => Record<`data-${string}`, string | number | boolean | undefined>;
  onDragStart?: (
    event: React.DragEvent<HTMLDivElement>,
    row: GridValidRowModel
  ) => void;
  onDragEnd?: (
    event: React.DragEvent<HTMLDivElement>,
    row: GridValidRowModel
  ) => void;
};

export const DataGridCustomRow = memo(({
  rowDataAttributes,
  ...gridRowProps
}: DataGridCustomRowProps) => {
  const dragTipRef = useRef(null);

  const onDragStart = (event: React.DragEvent<HTMLDivElement>) => {
    if (dragTipRef.current) {
      event.dataTransfer.setDragImage(dragTipRef.current, -20, 8);
    }

    const { row } = gridRowProps;
    if (row === undefined) {
      throw new Error("The row should exist");
    }

    gridRowProps.onDragStart?.(event, row);
  };

  const onDragEnd = (event: React.DragEvent<HTMLDivElement>) => {
    gridRowProps.onDragEnd?.(event, gridRowProps.row);
  };

  return (
    <Box
      draggable
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      data-testid={gridRowProps.row?._id ? `${testIds.lynksTableRow}-${gridRowProps.row?._id}` : undefined}
      {...rowDataAttributes?.(gridRowProps.row)}
    >
      <Box
        ref={dragTipRef}
        // Utilize an existing and off-screen HTMLElement as the drag feedback image.
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        sx={(theme) => ({
          position: "fixed",
          left: -10000,
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          p: 1,
        })}
      >
        {`1 selected row`}
      </Box>
      <GridRow {...gridRowProps} />
    </Box>
  );
});
